import React from "react";
import { graphql } from "gatsby";
import { PrismicRichText } from "@prismicio/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import * as styles from "./Testimonials.module.scss";
import VisuallyHidden from "../../components/VisuallyHidden";

import "swiper/css";
import "swiper/css/effect-fade";

const Testimonial = ({ item }) => {
  return (
    <div className={styles.testimonial}>
      <div>
        <div className={styles.testimonialText}>
          <PrismicRichText field={item.content.richText} />
        </div>
        <div className={styles.testimonialClient}>
          {item.client_logo?.url && (
            <img src={item.client_logo.url} alt={item.client_name} />
          )}
          <VisuallyHidden>{item.client_name}</VisuallyHidden>
        </div>
      </div>
    </div>
  );
};

export const Testimonials = ({ slice }) => {
  const { heading, color_scheme } = slice?.primary || {};
  const items = slice?.items || [];

  return (
    <section className={styles.testimonials} data-color-scheme={color_scheme || "white"}>
      <div className={`page-width text-center ${styles.container}`}>
        {heading?.richText && (
          <PrismicRichText field={heading.richText} components={{ heading2: ({ children }) => <h2 className="h3">{children}</h2> }} />
        )}
        <div>
          {items.length > 1 ? (
            <Swiper
              modules={[Autoplay, EffectFade]}
              autoplay={{
                delay: 10000,
              }}
              speed={500}
              allowTouchMove={false}
              simulateTouch={false}
              autoHeight={true}
              rewind
              slidesPerView={1}
              slidesPerGroup={1}
              centeredSlides
              effect="fade"
              fadeEffect={{
                crossFade: true,
              }}
            >
              {items.map((item, index) => (
                <SwiperSlide key={index}>
                  <Testimonial item={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            items.map((item, index) => <Testimonial key={index} item={item} />)
          )}
        </div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment AboutPageDataBodyTestimonials on PrismicAboutPageDataBodyTestimonials {
    primary {
      heading {
        richText
        text
      }
      color_scheme
    }
    items {
      client_logo {
        url
        alt
      }
      client_name
      content {
        richText
        text
      }
    }
  }
`;